export class UserInfo {
  id: number;
  fullName: string;
  capacity: string;
  isArchived: boolean;
}
